module.exports = __webpack_public_path__ + "img/Broken Prong.d7e33856.png";